<template>
  <div class="list-main">
    <div
      v-for="(item, index) in props.contentList"
      :key="index"
      class="list-with-image"
    >
      <a :href="item.url">
        <div class="list-with-image-content-left">
          <div class="list-with-image-content-left-image">
            <!-- <img :src="item.coverImageUrl" /> -->
            <el-image :src="item.coverImageUrl" fit="cover"></el-image>
          </div>
          <div class="list-with-image-content-left-tag">
            <span class="list-with-image-content-left-tag-time">
              <span class="list-with-image-content-left-tag-time-dy">
                {{ new Date(item.publishTime).getDate() }}
              </span>
              <span class="list-with-image-content-left-tag-time-ny">
                {{
                  new Date(item.publishTime).getFullYear() +
                  '.' +
                  (new Date(item.publishTime).getMonth() + 1)
                }}
              </span>
            </span>
            <span class="list-with-image-content-left-tag-read">
              <span class="list-with-image-content-left-tag-read-eye"></span>
              <span class="list-with-image-content-left-tag-read-count">
                {{ item.readCount }}
              </span>
            </span>
          </div>
        </div>
        <div class="list-with-image-content-title">
          {{ item.title }}
        </div>
        <div class="list-with-image-content-digest">
          {{ item.digest ? item.digest : '暂无摘要' }}
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
// #region 引用

// #endregion

// #region props/emit
const props = defineProps({
  contentList: {
    type: Array,
    default: [],
  },
});
// #endregion

// #region 变量/常量

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

// #endregion
</script>
<style scoped lang="scss">
@media screen and (device-width >= 1180px) {
  .list-main {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
  }

  .list-with-image {
    display: flex;
    flex-flow: column wrap;
    width: calc((100% - 60px) / 4);
    overflow: hidden;
    background-color: #e7edf4;
  }

  .list-with-image a {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .list-with-image-content-left {
    position: relative;
    display: flex;
    flex: 1;
  }

  .list-with-image-content-left-image {
    flex: 1;
    height: 160px;
    transition: all 0.5s ease;
  }

  .list-with-image-content-left-image .el-image {
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;
  }

  .list-with-image:hover .list-with-image-content-left-image .el-image {
    transform: translateX(5px);
  }

  .list-with-image-content-left-tag {
    position: absolute;
    top: 0;
    left: 20px;
    width: 70px;
    color: white;
    text-align: center;
    background: #008bd5;
    opacity: 0.9;
  }

  .list-with-image-content-left-tag span {
    display: inline-block;
  }
  .list-with-image-content-left-tag-time {
    display: flex;
    padding: 3px 0;

    /* flex-direction: column; */
  }

  .list-with-image-content-left-tag-time-dy {
    font-size: 18px;
    color: #fff;
  }

  .list-with-image-content-left-tag-time-ny {
    width: 100%;
    font-size: 16px;
  }

  .list-with-image-content-left-tag-read {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 3px 0;
    font-size: 14px;
    color: #888;
    background: #fff;
  }

  .list-with-image-content-left-tag-read-eye {
    display: inline-block;
    width: 15px;
    height: 12px;
    margin-right: 3px;
    background: url('./image/eye.png') no-repeat;
    background-size: cover;
  }

  .list-with-image-content-title {
    display: block;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 10px;
    overflow: hidden;
    font-size: 15px;
    font-weight: 600;
    line-height: 50px;
    color: #444;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.5s ease;
    -webkit-box-orient: vertical;
  }

  .list-with-image-content-digest {
    display: -webkit-box; /* 对于旧版WebKit浏览器（如旧版Safari和Android WebView） */
    width: 100%;
    padding: 0 10px;
    margin-bottom: 15px;
    overflow: hidden; /* 隐藏超出部分 */
    font-size: 14px;
    color: #666;
    text-overflow: ellipsis; /* 用省略号代替超出部分 */
    -webkit-line-clamp: 2; /* 限制显示的行数 */
    word-wrap: break-word; /* 防止长单词或URL无法换行 */
    white-space: normal; /* 允许文本换行 */
    -webkit-box-orient: vertical; /* 设置盒子为垂直方向 */
  }
}
</style>

<style scoped lang="scss">
@media screen and (device-width <= 1180px) {
  .list-main {
    display: flex;
    flex-flow: row wrap;
    gap: 4vw;
  }
  .list-with-image {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid #ccc;
  }

  .list-with-image-content {
    display: flex;
    flex-direction: column;
    margin: 2.5vw;
  }

  .list-with-image-content-left {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 60vw;
  }

  .list-with-image-content-left-image {
    width: 100%;
    height: 60vw;
    transition: all 0.5s ease;
  }

  .list-with-image-content-left-image .el-image {
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;
  }
  .list-with-image:hover {
    border-bottom: 1px solid #ccc;
  }

  .list-with-image:hover .list-with-image-content-left-image img,
  .list-with-image:hover .list-with-image-content-right-title {
    transform: translateX(5px);
  }

  .list-with-image-content-left-tag {
    position: absolute;
    top: 0;
    left: 5%;
    width: 17.5vw;
    color: white;
    text-align: center;
    background: #008bd5;
    opacity: 0.9;
  }

  .list-with-image-content-left-tag span {
    display: inline-block;
  }
  .list-with-image-content-left-tag-time {
    display: flex;

    /* flex-direction: column; */
  }

  .list-with-image-content-left-tag-time-dy {
    font-size: 10vw;
    color: #fff;
  }

  .list-with-image-content-left-tag-time-ny {
    width: 100%;
    font-size: 4vw;
  }

  .list-with-image-content-left-tag-read {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: 1vw 0;
    font-size: 4vw;
    color: #888;
    background: #fff;
  }

  .list-with-image-content-left-tag-read-eye {
    display: inline-block;
    width: 4vw;
    height: 2.5vw;
    margin-right: 1vw;
    background: url('./image/eye.png') no-repeat;
    background-size: cover;
  }

  .list-with-image-content-title {
    display: block;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 2vw;
    overflow: hidden;
    font-size: 4.5vw;
    font-weight: 600;
    line-height: 2em;
    color: #444;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.5s ease;
    -webkit-box-orient: vertical;
  }

  .list-with-image-content-digest {
    display: -webkit-box; /* 对于旧版WebKit浏览器（如旧版Safari和Android WebView） */
    width: 100%;
    margin-top: 1vw;
    margin-bottom: 3vw;
    overflow: hidden; /* 隐藏超出部分 */
    font-size: 4vw;
    color: #666;
    text-overflow: ellipsis; /* 用省略号代替超出部分 */
    -webkit-line-clamp: 2; /* 限制显示的行数 */
    word-wrap: break-word; /* 防止长单词或URL无法换行 */
    white-space: normal; /* 允许文本换行 */
    -webkit-box-orient: vertical; /* 设置盒子为垂直方向 */
  }
}
</style>
